import { useState, useEffect } from "react";

function useMediaQuery(mediaQuery) {
  const [isMatch, setIsMatch] = useState(false);

  function updateIsMatch(e) {
    setIsMatch(e.matches);
  }

  useEffect(() => {
    if (typeof window == "undefined" || typeof window.matchMedia == "undefined") return;

    const mediaQueryList = window.matchMedia(mediaQuery);
    const hasAddEventListener = typeof mediaQueryList.addEventListener !== "undefined";
    const hasAddListener = typeof mediaQueryList.addListener !== "undefined";

    setIsMatch(mediaQueryList.matches);

    if (hasAddEventListener) {
      mediaQueryList.addEventListener("change", updateIsMatch);
      return () => mediaQueryList.removeEventListener("change", updateIsMatch);
    }

    if (!hasAddEventListener && hasAddListener) {
      mediaQueryList.addListener(updateIsMatch);
      return () => mediaQueryList.removeListener(updateIsMatch);
    }
  }, [mediaQuery]);

  return isMatch;
}

export default useMediaQuery;
